export default __webpack_public_path__ + "static/media/icon_8.4a12dc7b.png";